// import React, { useEffect } from 'react';
import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import './styles/MapboxAfiliation.css';
import { dataExample } from './dataExample';

function calcularPuntoMedio(coordenadas1, coordenadas2) {
  // Extraer las coordenadas de los puntos
  const [x1, y1] = coordenadas1;
  const [x2, y2] = coordenadas2;

  // Calcular el punto medio
  const puntoMedioX = (x1 + x2) / 2;
  const puntoMedioY = (y1 + y2) / 2;

  return [puntoMedioX, puntoMedioY];
}
function bitsToGB(bits) {
  const bytes = bits / 8;
  const kilobytes = bytes / 1024;
  const megabytes = kilobytes / 1024;
  const gigabytes = megabytes / 1024;
  return megabytes;
}
function bitsToGigabits(bits) {
  const gigabits = bits / 1e6; // 1e9 es equivalente a 1 billion (mil millones)
  return gigabits;
}

const MapboxAfiliation = ({ showCorrelationsMO, showCorrelationsFO, markersWOR, statusFilter, filteredEvents, dataAgencies, markersUnknown, setExceptData, setPopups, setShowPopups, exceptions, capas, switchesFO, switchesMO, setCapas, actualizar_rfi, actualizar_lpr, mapAux, setmapAux, search_rfid, global_longitud, global_latitude, global_zoom, devices, markers, lines, downs, towers, rfid, lpr, ubicacion, switches, handleMarkerClick }) => {

  const afiliacionesNamesSet = new Set(
    filteredEvents.map(a => a.properties.name)
  );

  const correlacionesFiltradasMO = switchesMO.filter(c => {
    const { hostidC, hostidP } = c.properties;

    return (
      afiliacionesNamesSet.has(hostidC) &&
      afiliacionesNamesSet.has(hostidP)
    );
  });
  const correlacionesFiltradasFO = switchesFO.filter(c => {
    const { hostidC, hostidP } = c.properties;

    return (
      afiliacionesNamesSet.has(hostidC) &&
      afiliacionesNamesSet.has(hostidP)
    );
  });


  let latitud_provicional = (ubicacion.groupid === 0 ? global_latitude.value : ubicacion.latitud)
  let longitud_provicional = (ubicacion.groupid === 0 ? global_longitud.value : ubicacion.longitud)
  const zoom_provicional = (ubicacion.groupid === 0 ? global_zoom.value : 11)
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const [rfidInterval, setRfidInterval] = useState(0)
  const [lprInterval, setLprInterval] = useState(0)
  const idCapaExistente = (id) => {
    return Object.values(capas).some(capa => capa.id === id);
  };


  mapboxgl.accessToken =
    'pk.eyJ1IjoiZ2lvcm9jaGEiLCJhIjoiY2xpZWJyZTR3MHpqcjNlcWRvaHR1em5sayJ9._SOrMWsc39Coa2dTHR072Q';



  useEffect(() => {
    mapRef.current = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/light-v11',
      zoom: zoom_provicional,
      center: [longitud_provicional, latitud_provicional]

    });
    let Popup;
    const map = mapRef.current;
    setmapAux(map)

    const unclusteredMarkers = Object.create(null);

    /* ---------- Helper: generar clave estable para una feature ---------- */
    function featureKey(f) {
      if (f.id !== undefined && f.id !== null) return String(f.id);
      const coords = (f.geometry && f.geometry.coordinates) ? f.geometry.coordinates.join(',') : 'no-coords';
      const name = (f.properties && (f.properties.name || f.properties.title)) || '';
      return `${coords}__${name}`;
    }

    /* ---------- Tu función que crea el badge DOM (ajusta propiedades según tu GeoJSON) ---------- */
    function createBadgeElement(properties = {}) {

      const obj = JSON.parse(properties.stats)
      const hosts = JSON.parse(properties.hosts)
      const name = properties.name || properties.title || 'dispositivo';
      const ok = hosts.filter(h => h.status === 'ok').length ?? 0
      // const ok = obj.breakdown.ok ?? properties.conectados ?? properties.c1 ?? 0;
      const warn = hosts.filter(h => h.status === 'offline').length ?? 0
      // const warn = obj.breakdown.offline ?? properties.desconectados ?? properties.c2 ?? 0;
      const unk = hosts.filter(h => h.status === 'unknown').length ?? 0
      // const unk = obj.breakdown.unknown ?? properties.desconocidos ?? properties.c3 ?? 0;
      const maintenance = hosts.filter(h => h.in_maintenance === true).length ?? 0
      // const maintenance = obj.breakdown.maintenance ?? properties.conectados ?? properties.c1 ?? 0;
      const exceptions = hosts.filter(h => h.is_exception === true).length ?? 0
      // const exceptions = obj.breakdown.exceptions ?? properties.desconectados ?? properties.c2 ?? 0;

      const wrapper = document.createElement('div');
      wrapper.className = 'badge-marker';

      const label = document.createElement('div');
      label.className = 'badge-label';
      label.textContent = name;
      wrapper.appendChild(label);

      const counts = document.createElement('div');
      counts.className = 'badge-counts';

      const green = document.createElement('div');
      green.className = 'badge-dot green';
      green.textContent = ok;

      const red = document.createElement('div');
      red.className = 'badge-dot red';
      red.textContent = warn;

      const gray = document.createElement('div');
      gray.className = 'badge-dot gray';
      gray.textContent = unk;

      const purple = document.createElement('div');
      purple.className = 'badge-dot purple';
      purple.textContent = exceptions;

      const yellow = document.createElement('div');
      yellow.className = 'badge-dot yellow';
      yellow.textContent = maintenance;

      if (ok === 0) {
        green.style.display = 'none'
      }
      if (warn === 0) {
        red.style.display = 'none'
      }
      if (unk === 0) {
        gray.style.display = 'none'
      }
      if (exceptions === 0) {
        purple.style.display = 'none'
      }
      if (maintenance === 0) {
        yellow.style.display = 'none'
      }
      counts.appendChild(green);
      counts.appendChild(red);
      counts.appendChild(gray);
      counts.appendChild(purple);
      counts.appendChild(yellow);
      wrapper.appendChild(counts);

      // outline y punta (si ya lo tienes en markup original omítelos)
      const outline = document.createElement('div');
      outline.className = 'badge-tail-outline';
      wrapper.appendChild(outline);

      const tail = document.createElement('div');
      tail.className = 'badge-tail';
      wrapper.appendChild(tail);

      return wrapper;
    }

    /* ---------- Sincronización: mapear los markers DOM a las features renderizadas ---------- */
    function syncMarkersWithRenderedUnclustered() {
      // intenta obtener features que Mapbox realmente está renderizando en la layer 'unclustered-point'
      let rendered = [];
      try {
        rendered = map.queryRenderedFeatures({ layers: ['unclustered-point'] });
      } catch (err) {
        // la layer puede no existir aún; limpiamos todos los markers
        // console.warn('queryRenderedFeatures error:', err);
        rendered = [];
      }

      const visibleKeys = new Set(rendered.map(f => featureKey(f)));

      // eliminar markers que ya no están visibles
      Object.keys(unclusteredMarkers).forEach(key => {
        if (!visibleKeys.has(key)) {
          try { unclusteredMarkers[key].remove(); } catch (e) { }
          delete unclusteredMarkers[key];
        }
      });

      // añadir o actualizar markers para features visibles
      // rendered.forEach(f => {
      //   const key = featureKey(f);
      //   const coords = f.geometry.coordinates;
      //   const props = f.properties || {};

      //   if (unclusteredMarkers[key]) {
      //     // actualiza posición si cambió (evita recrear DOM)
      //     try {
      //       unclusteredMarkers[key].setLngLat(coords);
      //     } catch (e) {
      //       try { unclusteredMarkers[key].remove(); } catch (_) {}
      //       delete unclusteredMarkers[key];
      //     }
      //   }

      //   if (!unclusteredMarkers[key]) {
      //     const el = createBadgeElement(props);
      //     // opcional: añadir eventos
      //     // el.addEventListener('click', () => { /* abrir popup etc. */ });

      //     const marker = new mapboxgl.Marker({ element: el, anchor: 'bottom' })
      //       .setLngLat(coords)
      //       .addTo(map);

      //     unclusteredMarkers[key] = marker;
      //   }
      // });
      rendered.forEach(f => {
        const key = featureKey(f);
        const coords = f.geometry.coordinates;
        const props = f.properties || {};

        if (unclusteredMarkers[key]) {
          // ACTUALIZACIÓN: Actualizamos el HTML del marcador existente
          const existingElement = unclusteredMarkers[key].getElement();
          const newBadge = createBadgeElement(props); // Creamos el nuevo diseño con datos frescos

          // Reemplazamos el contenido interno para que se vean los nuevos números
          existingElement.innerHTML = newBadge.innerHTML;

          unclusteredMarkers[key].setLngLat(coords);
        }

        if (!unclusteredMarkers[key]) {
          const el = createBadgeElement(props);
          const marker = new mapboxgl.Marker({ element: el, anchor: 'bottom' })
            .setLngLat(coords)
            .addTo(map);

          unclusteredMarkers[key] = marker;
        }
      });
      // DEBUG opcional:
      // console.log('rendered:', rendered.length, 'markers:', Object.keys(unclusteredMarkers).length);
    }

    /* ---------- Insertar source + layers (clusters) y la layer unclustered-point ---------- */
    map.on('load', () => {
      // 1) agrega la source con cluster: true
      map.addSource('earthquakes', {
        type: 'geojson',
        // Ajusta aquí: tu URL o tu variable GeoJSON
        // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson',
        data: {
          type: 'FeatureCollection',
          features: markersWOR
        },
        generateId: true,
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 50
      });

      // busca primera layer symbol para insertar antes (evita que labels tapen tus circles)
      const firstSymbolId = map.getStyle().layers.find(l => l.type === 'symbol')?.id;

      // 2) layer de clusters (círculos)
      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'earthquakes',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': [
            'step',
            ['get', 'point_count'],
            '#8fd573',
            100,
            '#58a23b',
            750,
            '#21510e'
          ],
          'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
          'circle-stroke-width': 4,
          'circle-stroke-color': [
            'step',
            ['get', 'point_count'],
            '#8fd573',
            100,
            '#58a23b',
            750,
            '#21510e'
          ],
          'circle-stroke-opacity': 0.5,
          'circle-opacity': 0.9
        }
      }, firstSymbolId);

      // 3) texto del cluster (conteo)
      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'earthquakes',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        },
        paint: {
          'text-color': '#0b3b07'
        }
      }, firstSymbolId);

      // 4) layer para puntos no agrupados (necesaria para queryRenderedFeatures)
      map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'earthquakes',
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-color': '#11b4da',
          'circle-radius': 8,
          'circle-stroke-width': 2,
          'circle-stroke-color': '#ffffff',
          'circle-opacity': 0 // lo hacemos invisibles porque usamos Markers DOM para la UI
        }
      }, firstSymbolId);


      // map.on('mouseleave', 'unclustered-point', (e) => {
      //     // Popup.remove();
      //     const popups = document.querySelectorAll('.custom-popup');

      //     popups.forEach(popup => {

      //     popup.remove();
      //     });
      //     });
      map.on('mouseenter', 'unclustered-point', (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }


        const properties = e.features[0].properties;

        const hosts = JSON.parse(properties.hosts)
        const name = properties.name || properties.title || 'dispositivo';
        const ok = hosts.filter(h => h.status === 'ok').length ?? 0
        const warn = hosts.filter(h => h.status === 'offline').length ?? 0
        const unk = hosts.filter(h => h.status === 'unknown').length ?? 0
        const maintenance = hosts.filter(h => h.in_maintenance === true).length ?? 0
        const exceptions = hosts.filter(h => h.is_exception === true).length ?? 0
        Popup = new mapboxgl.Popup({
          className: 'custom-popup',
          closeButton: true,
        })
          .setLngLat(coordinates)
          .setHTML(`
<div class="cont-pop" style="
  width: 240px;
  font-family: Arial, sans-serif;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  background: #fff;
">

  <!-- Header -->
  <div style="
    background: #1f2b3a;
    color: #fff;
    padding: 10px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  ">
    <span>${properties.name}</span>
    <span style="
      background: #2f3f52;
      padding: 2px 8px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: normal;
    ">
      Total: ${ok + warn + unk}
    </span>
  </div>

  <!-- Body -->
  <div style="padding: 10px 12px; font-size: 11px; color: var(--txt-color);font-weight: normal;">
    
    <!-- Conectados -->
    <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
      <div style="display: flex; align-items: center; gap: 6px;">
        <span style="width: 10px; height: 10px; background: #2ecc71; border-radius: 50%; display: inline-block;"></span>
        <span>Conectados</span>
      </div>
      <b>${ok}</b>
    </div>

    <!-- Desconectados -->
    <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
      <div style="display: flex; align-items: center; gap: 6px;">
        <span style="width: 10px; height: 10px; background: #e74c3c; border-radius: 50%; display: inline-block;"></span>
        <span>Desconectados</span>
      </div>
      <b>${warn}</b>
    </div>

    <!-- Desconocidos -->
    <div style="display: flex; justify-content: space-between;">
      <div style="display: flex; align-items: center; gap: 6px;">
        <span style="width: 10px; height: 10px; background: #bdc3c7; border-radius: 50%; display: inline-block;"></span>
        <span>Desconocidos</span>
      </div>
      <b>${unk}</b>
    </div>

    <hr style="margin: 10px 0; border: none; border-top: 1px solid #eee;" />

    <!-- Extra info -->
    <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
      <span style="color: #f39c12;">🛠 En Mantenimiento</span>
      <b>${maintenance}</b>
    </div>

    <div style="display: flex; justify-content: space-between;">
      <span style="color: purple;">⚠ Excepciones</span>
      <b>${exceptions}</b>
    </div>

  </div>
</div>
`)

          // .setHTML(`<div class='cont-pop' style='border: 1px solid #ff0000;'>
          // <div>${e.features[0].properties.name.slice(0, 25)}...</div><br>
          // <div> Descripcion: <b style='color: #ff0000;'>${e.features[0].properties.descripcion}</b> </div>
          // </div>`)

          .addTo(map);

      });
      map.on('click', 'unclustered-point', (e) => {
        handleMarkerClick(e.features[0].properties)
      });
      // 5) Listeners: sincroniza cuando fuente cargue y cuando mapa se mueva/zoom
      // Llamamos a syncMarkersWithRenderedUnclustered en los eventos pertinentes:
      map.on('sourcedata', (e) => {
        if (e.sourceId === 'earthquakes' && e.isSourceLoaded) syncMarkersWithRenderedUnclustered();
      });

      // moveend y zoomend cuando termina la interacción UI (menos ruidoso)
      map.on('moveend', syncMarkersWithRenderedUnclustered);
      map.on('zoomend', syncMarkersWithRenderedUnclustered);

      // cuando el estilo cambia (map.setStyle(...)) limpia marcadores y reintenta
      map.on('styledata', () => {
        Object.keys(unclusteredMarkers).forEach(k => {
          try { unclusteredMarkers[k].remove(); } catch (_) { }
          delete unclusteredMarkers[k];
        });
        // espera un poco a que la layer se vuelva a crear (si aplica)
        setTimeout(syncMarkersWithRenderedUnclustered, 120);
      });

      // Llamada inicial por si la fuente ya está lista
      syncMarkersWithRenderedUnclustered();

      /************************************************************ CAPA LINEAS Switches ************************************************************************ */
      // if(switchesFO.length!==0 || switchesMO.length!==0){




      //   /**************************************************** */
      const throughtputSource = {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: correlacionesFiltradasFO
        }
      }

      map.addSource('line-throughtput', throughtputSource);


      const throughtputLayer = {
        type: 'line',
        source: 'line-throughtput',
        id: 'line-throughtput',
        paint: {

          'line-color': [
            'match',
            ['get', 'connectivity'],
            'ok', '#1fee08',
            'offline', 'red',
            '#a4a4a4', // Color predeterminado si no se cumplen las condiciones anteriores
          ],
          'line-width': 8,
          'line-dasharray': [0, 0.3, 0.2]
        }
      }
      map.addLayer(throughtputLayer);

      const dashArraySequence = [
        [0, 0.3, 0.2],
        [0, 0.1, 0.2, 0.4],
        [0, 0.2, 0.2, 0.3],
        [0, 0.3, 0.2, 0.2],
        [0, 0.4, 0.2, 0.1],
        [0, 0.5, 0.2, 0],

      ];

      let step = 0;

      function animateDashArray(timestamp) {
        const newStep = parseInt((timestamp / 50) % dashArraySequence.length);

        if (newStep !== step) {
          try {
            let layerExists = map.getLayer('line-throughtput');
            if (layerExists) {
              map.setPaintProperty('line-throughtput', 'line-dasharray', dashArraySequence[step]);
              // Puedes realizar operaciones adicionales aquí si la capa existe
            }
          } catch (error) {
            // console.log(error)
          }

          step = newStep;
        }

        requestAnimationFrame(animateDashArray);
      }

      // animateDashArray.bind(this)(0);

      //  if(!idCapaExistente('line-throughtput')){
      //    setCapas((prevCapas) => ({
      //      ...prevCapas,
      //      [Object.keys(prevCapas).length ]: { show: true, name: 'Fibra optica',id:`line-throughtput`,layer:throughtputLayer ,source:throughtputSource,nivel:2},
      //    }));
      //  }
      map.on('mouseleave', 'line-throughtput', (e) => {

        const popups = document.querySelectorAll('.custom-popup');

        popups.forEach(popup => {

          popup.remove();
        });
      });
      map.on('mouseenter', 'line-throughtput', (e) => {
        // console.log(e.features[0].properties.Metric)
        // console.log(JSON.parse(e.features[0].properties.Metric))
        const coordinates = calcularPuntoMedio(e.features[0].geometry.coordinates[0], e.features[0].geometry.coordinates[1])
        const data = JSON.parse(e.features[0].properties.Metric)

        //   const coordinates = e.features[0].geometry.coordinates.slice();


        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        Popup = new mapboxgl.Popup({
          className: 'custom-popup',
          closeButton: false,
        })
          .setLngLat(coordinates)

          .setHTML(`<div class='cont-pop' style='border: 1px solid ${e.features[0].properties.color_alineacion};width:300px'>
                    <div>
                    <div>${data.source} ---> ${data.target}</div>
                     <div>Medio: ${data.type}</div>
                    <table border="1" style='width:100%'>
              <thead class='headMetrics' style='background:var(--border-table-color)'>
                  <tr >
                      <th >Metrica</th>
                      <th >Valor</th>
                     
                  </tr>
              </thead>
              <tbody>
                  
                      <tr>
                          <td>${'Status'}</td>
                        <td>${(data.status == null) ? '' : data.status}</td>
                        
                      </tr>
                      <tr>
                          <td>${'Send'}</td>
                        <td>${(data.metrics.bw_send == null) ? '' : data.metrics.bw_send}</td>
                        
                      </tr>
                      <tr>
                          <td>${'Recv'}</td>
                        <td>${(data.metrics.bw_received == null) ? '' : data.metrics.bw_received}</td>
                       </tr>
                      
                  
              </tbody>
          </table>
          </div>
                   
                    
                    </div>`)
          .addTo(map);
      });
      /*********************************************************************************** */

      const throughtputSource2 = {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: correlacionesFiltradasMO
        }
      }
      map.addSource('line-throughtput2', throughtputSource2);


      const throughtputLayer2 = {
        type: 'line',
        source: 'line-throughtput2',
        id: 'line-throughtput2',
        paint: {

          'line-color': [
            'match',
            ['get', 'connectivity'],
            'ok', '#1fee08',
            'offline', 'red',
            '#a4a4a4', // Color predeterminado si no se cumplen las condiciones anteriores
          ],
          'line-width': 5,
          'line-dasharray': [0, 4, 3]
          // 'line-dasharray': [
          //   'match',
          //   ['get', 'connectivity'],
          //   0, ['solid'], // Valor cuando connectivity es 0
          //   1, [0, 4, 3], // Valor cuando connectivity es 1
          //   ['solid'] // Valor predeterminado si no se cumplen las condiciones anteriores
          // ]
        }
      }
      map.addLayer(throughtputLayer2);

      const dashArraySequence2 = [
        [0, 4, 3],
        [0.5, 4, 2.5],
        [1, 4, 2],
        [1.5, 4, 1.5],
        [2, 4, 1],
        [2.5, 4, 0.5],
        [3, 4, 0],
        [0, 0.5, 3, 3.5],
        [0, 1, 3, 3],
        [0, 1.5, 3, 2.5],
        [0, 2, 3, 2],
        [0, 2.5, 3, 1.5],
        [0, 3, 3, 1],
        [0, 3.5, 3, 0.5]
      ];

      let step2 = 0;

      function animateDashArray2(timestamp) {
        const newStep = parseInt((timestamp / 50) % dashArraySequence2.length);

        if (newStep !== step2) {
          try {
            let layerExists = map.getLayer('line-throughtput2');
            if (layerExists) {
              map.setPaintProperty('line-throughtput2', 'line-dasharray', dashArraySequence2[step2]);
              // Puedes realizar operaciones adicionales aquí si la capa existe
            }
          } catch (error) {
            // console.log(error)
          }

          step2 = newStep;
        }

        // requestAnimationFrame(animateDashArray2);
      }

      // animateDashArray2.bind(this)(0);

      //  if(!idCapaExistente('line-throughtput2')){
      //    setCapas((prevCapas) => ({
      //      ...prevCapas,
      //      [Object.keys(prevCapas).length ]: { show: true, name: 'Microonda',id:`line-throughtput2`,layer:throughtputLayer2 ,source:throughtputSource2,nivel:2},
      //    }));
      //  }
      map.on('mouseleave', 'line-throughtput2', (e) => {

        const popups = document.querySelectorAll('.custom-popup');

        popups.forEach(popup => {

          popup.remove();
        });
      });
      map.on('mouseenter', 'line-throughtput2', (e) => {

        const coordinates = calcularPuntoMedio(e.features[0].geometry.coordinates[0], e.features[0].geometry.coordinates[1])
        // console.log(coordinates)
        //   const coordinates = e.features[0].geometry.coordinates.slice();

        const data = JSON.parse(e.features[0].properties.Metric)
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        Popup = new mapboxgl.Popup({
          className: 'custom-popup',
          closeButton: false,
        })
          .setLngLat(coordinates)
          .setHTML(`<div class='cont-pop' style='border: 1px solid ${e.features[0].properties.color_alineacion};width:300px'>
                    <div>
                    <div>${data.source} ---> ${data.target}</div>
                     <div>Medio: ${data.type}</div>
                    <table border="1" style='width:100%'>
              <thead class='headMetrics' style='background:var(--border-table-color)'>
                  <tr >
                      <th >Metrica</th>
                      <th >Valor</th>
                     
                  </tr>
              </thead>
              <tbody>
                  
                      <tr>
                          <td>${'Status'}</td>
                        <td>${(data.status == null) ? '' : data.status}</td>
                        
                      </tr>
                      <tr>
                          <td>${'Send'}</td>
                        <td>${(data.metrics.bw_send == null) ? '' : data.metrics.bw_send}</td>
                        
                      </tr>
                      <tr>
                          <td>${'Recv'}</td>
                        <td>${(data.metrics.bw_received == null) ? '' : data.metrics.bw_received}</td>
                       </tr>
                      
                  
              </tbody>
          </table>
          </div>
                   
                    
                    </div>`)
          //         .setHTML(`<div class='cont-pop' style='border: 1px solid ${e.features[0].properties.color_alineacion};width:500px'>
          //           <div>
          //           <div>${data.host_padre} ---> ${data.host_hijo}</div>
          //            <div>Medio: ${data.medio}</div>
          //           <table border="1" style='width:100%'>
          //     <thead class='headMetrics' style='background:var(--border-table-color)'>
          //         <tr >
          //             <th >Metrica</th>
          //             <th >Bruto</th>
          //             <th >interpretado</th>
          //             <th >Hora</th>
          //         </tr>
          //     </thead>
          //     <tbody>

          //             <tr>
          //                 <td>${'Status'}</td>
          //               <td>${(data.valor_status_enlace==null)?'':data.valor_status_enlace}</td>
          //               <td>${(data.itemname_status_enlace==null)?'':data.itemname_status_enlace}</td>
          //               <td>${(data.hora_status_enlace==null)?'':data.hora_status_enlace}</td>
          //             </tr>
          //             <tr>
          //                 <td>${'Send'}</td>
          //               <td>${(data.valor_throughput_send==null)?'':data.valor_throughput_send}</td>
          //               <td>${(data.itemname_throughput_send==null)?'':data.itemname_throughput_send}</td>
          //               <td>${(data.hora_throughput_send==null)?'':data.hora_throughput_send}</td>
          //             </tr>
          //             <tr>
          //                 <td>${'Recv'}</td>
          //               <td>${(data.valor_throughput_received==null)?'':data.valor_throughput_received}</td>
          //               <td>${(data.itemname_throughput_received==null)?'':data.itemname_throughput_received}</td>
          //               <td>${(data.hora_throughput_received==null)?'':data.hora_throughput_received}</td>
          //             </tr>
          //             <tr>
          //                 <td>${'Alineación'}</td>
          //               <td>${(data.valor_alineacion==null)?'':data.valor_alineacion}</td>
          //               <td>${(data.itemname_alineacion==null)?'':data.itemname_alineacion}</td>
          //               <td>${(data.hora_alineacion==null)?'':data.hora_alineacion}</td>
          //             </tr>

          //     </tbody>
          // </table>
          // </div>


          //           </div>`)
          .addTo(map);
      });






    });


    return () => map.remove();
  }, [downs]);
  useEffect(() => {
    const map = mapRef.current;
    if (!map || typeof map.getSource !== 'function') return;

    const src = map.getSource('earthquakes');
    if (!src) return; // la source aún no fue añadida (map aún no cargó)

    // normalizamos filteredEvents para aceptar:
    // - un array de features
    // - o un FeatureCollection { type:'FeatureCollection', features: [...] }
    let featuresToSend = [];

    if (Array.isArray(filteredEvents)) {
      // si ya es array de features
      featuresToSend = filteredEvents;
    } else if (filteredEvents && Array.isArray(filteredEvents.features)) {
      // si es FeatureCollection
      featuresToSend = filteredEvents.features;
    } else if (Array.isArray(markersWOR)) {
      // caso donde markersWOR es la variable que usas: array de features
      featuresToSend = markersWOR;
    } else if (Array.isArray(markersWOR?.features)) {
      featuresToSend = markersWOR.features;
    }

    // construir GeoJSON seguro
    const safeGeoJSON = {
      type: 'FeatureCollection',
      features: featuresToSend || []
    };

    try {
      src.setData(safeGeoJSON);
      // no hace falta llamar manualmente a syncMarkersWithRenderedUnclustered,
      // tu listener "sourcedata" lo ejecutará cuando la source se cargue.
    } catch (err) {
      console.error('setData error:', err, { safeGeoJSON, filteredEvents, markersWOR });
    }
  }, [filteredEvents, markersWOR, statusFilter]);
  useEffect(() => {
    const map = mapRef.current;
    if (!map || typeof map.getSource !== 'function') return;

    const src = map.getSource('line-throughtput2');
    if (!src) return; // la source aún no existe

    let featuresToSend = [];

    // normalización igual que en afiliaciones
    if (Array.isArray(correlacionesFiltradasMO)) {
      featuresToSend = correlacionesFiltradasMO;
    } else if (correlacionesFiltradasMO?.type === 'FeatureCollection') {
      featuresToSend = correlacionesFiltradasMO.features || [];
    }

    const safeGeoJSON = {
      type: 'FeatureCollection',
      features: featuresToSend
    };

    try {
      src.setData(safeGeoJSON);
    } catch (err) {
      console.error('setData correlaciones error:', err, safeGeoJSON);
    }
  }, [correlacionesFiltradasMO]);
  useEffect(() => {
    const map = mapRef.current;
    if (!map || typeof map.getSource !== 'function') return;

    const src = map.getSource('line-throughtput');
    if (!src) return; // la source aún no existe

    let featuresToSend = [];

    // normalización igual que en afiliaciones
    if (Array.isArray(correlacionesFiltradasFO)) {
      featuresToSend = correlacionesFiltradasFO;
    } else if (correlacionesFiltradasFO?.type === 'FeatureCollection') {
      featuresToSend = correlacionesFiltradasFO.features || [];
    }

    const safeGeoJSON = {
      type: 'FeatureCollection',
      features: featuresToSend
    };

    try {
      src.setData(safeGeoJSON);
    } catch (err) {
      console.error('setData correlaciones error:', err, safeGeoJSON);
    }
  }, [correlacionesFiltradasFO]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    if (!map.getLayer('line-throughtput2')) return;

    map.setLayoutProperty(
      'line-throughtput2',
      'visibility',
      showCorrelationsMO ? 'visible' : 'none'
    );
  }, [showCorrelationsMO]);
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    if (!map.getLayer('line-throughtput')) return;

    map.setLayoutProperty(
      'line-throughtput',
      'visibility',
      showCorrelationsFO ? 'visible' : 'none'
    );
  }, [showCorrelationsFO]);
  return <div id="map" style={{ position: 'absolute', top: 0, bottom: 0, width: '100%' }} />;

};


export default MapboxAfiliation;
